$(document).ready(function(){
  var startBlog = Date.now();

  $("[data-comment-reply]").bind("click",function(){
    var index = $("[data-comment-row]").index($(this).closest("[data-comment-row]"));
    $("[data-comment-form]").insertAfter($("[data-comment-row]").eq(index));
    $("[data-comment-cancel]").show();
    $("[data-comment-form]").find("input[name='replay_to']").val($(this).closest("[data-comment-row]").attr("data-comment-row"));
  });

  $("[data-comment-cancel]").bind("click",function(){
    $("[data-comment-form]").insertAfter($("[data-comment-row]:last"));
    $("[data-comment-cancel]").hide();
    $("[data-comment-form]").find("input[name='replay_to']").val("");
  });

  $("[data-comment-form]").submit(function(){
    var submitBlog = Date.now();
    if($(this).valid() && (submitBlog-startBlog)/1000>6){
      return true;
    }else{
      return false;
    }
  });
});
